export const newsMappings = {
  Announcements: {
    en: 'Announcements',
    nb: 'Kunngjøringer',
  },
  Announcement: {
    en: 'Announcement',
    nb: 'Kunngjøring',
  },
  NewsAnnouncements: {
    en: 'Announcements',
    nb: 'Kunngjøringer',
  },
  CreateANewAnnouncement: {
    en: 'Announcement',
    nb: 'Kunngjøring',
  },
  ConfirmSendingNewsTitle: {
    en: 'Confirm sending email and notification',
    nb: 'Bekreft å sende e-post og varsel',
  },
  ConfirmSendingNewsWithoutEmailTitle: {
    en: 'Confirm sending notification without email',
    nb: 'Bekreft å sende varsel uten e-post',
  },
  PublishMessage: {
    en: 'An email and notification will be sent indicating that this announcement has been published.',
    nb: 'En e-post og varsel vil bli sendt om at denne kunngjøringen er publisert.',
  },
  PublishMessageNoEmail: {
    en: 'A notification will be sent indicating that this announcement has been published.',
    nb: 'Et varsel vil bli sendt om at denne kunngjøringen er publisert.',
  },
  PublishMessageNoExtraInEmail: {
    en: 'The email will only contain the title of the announcement. Be careful not to include sensitive information in the announcement title.',
    nb: 'E-posten vil kun inneholde tittelen til kunngjøringen. Vær forsiktig med å legge sensitiv informasjon i kunngjøringtittelen.',
  },
  PublishMessageAttachementInEmailText: {
    en: 'The email will contain the announcement title and the attached files belonging to the announcement. Be careful not to include sensitive information in the attachments or the announcement title.',
    nb: 'E-posten vil inneholde kunngjøringtittelen og vedlagte filer som tilhører kunngjøringen. Vær forsiktig med å legge sensitiv informasjon i vedleggene og kunngjøringtittlen.',
  },
  PublishMessageDescriptionInEmailText: {
    en: 'The email will contain the description and the title of the announcement. Be careful not to include sensitive information in the announcement.',
    nb: 'E-posten vil inneholde beskrivelsen og kunngjøringtittelen som tilhører kunngjøringen. Vær forsiktig med å legge sensitiv informasjon i kunngjøringen.',
  },
  PublishMessageAllInEmailText: {
    en: 'The email will contain the description and the attachments belonging to the announcement. Be careful not to include sensitive information in the announcement or attachments.',
    nb: 'E-posten vil inneholde beskrivelsen og vedleggene som tilhører kunngjøringen. Vær forsiktig med å legge sensitiv informasjon i kunngjøringen eller vedleggene.',
  },
  Theadministratorcanpostme: {
    en: 'Administrator users can post announcements to registered users. The announcements can be directed to all users or restricted to those with board access.',
    nb: 'Administratorbrukere kan publisere kunngjøringer til registrerte brukere. Kunngjøringene kan rettes til alle brukere eller begrenses til de med styretilgang.',
  },
  Theadministratorcanpostme2: {
    en: 'Users with access to an announcement can open it and read the content. Users also have access to start a conversation about an announcement, either with a custom group or an existing contact group.',
    nb: 'Brukere som har tilgang på en kunngjøring kan åpne den og lese innholdet. Brukerne har også tilgang til å starte en samtale om en kunngjøring, enten med en egendefinert gruppe eller en eksisterende kontaktgruppe.',
  },
  Themessageisvisibleto: {
    en: 'The announcement is visible to',
    nb: 'Kunngjøring er synlig for',
  },
  YouHaveReceivedNewAnnouncementFrom: {
    en: 'You have received a new announcement from {{organizationName}}.',
    nb: 'Du har mottatt en ny kunngjøring fra {{organizationName}}.',
  },
} as const;

export type NewsMappingKey = keyof typeof newsMappings;
